module.exports = __webpack_public_path__ + "h5assets/img/submitSuccess.9cb24a3.svg";